// Global constants
export const NEW_NOTIFICATION = "notifications/NEW_NOTIFICATION";
export const GET_NEXT_NOTIFICATION = "notifications/GET_NEXT_NOTIFICATION";
export const EMPTY_CURRENT_NOTIFICATION =
  "notifications/EMPTY_CURRENT_NOTIFICATION";

// Local constants
export const ADD_NEW = "ADD_NEW";
export const GET_NEXT = "GET_NEXT";
export const EMPTY_CURRENT = "EMPTY_CURRENT";
